import { Modalator } from 'hegyd/core/resources/assets/js/utils/Modalator.js'

export default class RemoveBtn extends HTMLAnchorElement {
    connectedCallback() {
        this.addEventListener('click', (e) => {
            e.preventDefault();

            const url = this.dataset.href;
            const modal = new Modalator();

            modal.initRemoteModal('#modal-remove-my-account', url, null, (data) => {
                // TODO : remettre à jour les infos de la page
            });
        });
    }
}
